import { EventEmitter } from '@angular/core';

export abstract class AddToWatchlist {
  symbolAdded: EventEmitter<void>;
}
